import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useResizeDetector } from 'react-resize-detector';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { isProviderApp } from 'ziphy-web-shared/basic/helpers';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import mapStyles from '@library/map/mapStyles.json';
import PointMarker from '@assets/images/map/point-marker.svg';
import PointMarkerKerna from '@assets/images/map/point-marker-kerna.svg';
import { useSelectedBrand } from '@core/src/hooks/useSelectedBrand';
import styles from './ApptMap.module.scss';
const options = {
    styles: mapStyles,
    disableDefaultUI: true,
    gestureHandling: 'none',
    zoom: 16,
};
const ApptMap = ({ byRoute, className }) => {
    var _a;
    const { ref, width = 0, height = 0 } = useResizeDetector();
    const { isZiphy } = useSelectedBrand();
    const PointMarkerIcon = isZiphy ? PointMarker : PointMarkerKerna;
    const { fullAppt, status } = byRoute;
    const { place } = fullAppt;
    const isSuccess = isProviderApp() ? status.isDone : status.isSuccess;
    const isCompleted = !((_a = status.payAttention) === null || _a === void 0 ? void 0 : _a.length) && isSuccess;
    const coords = place.coords;
    const getShiftedCenter = useMemo(() => {
        let lat = coords.lat;
        let lng = coords.lng;
        return {
            lat: lat,
            lng: lng,
        };
    }, [height, coords]);
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: place && (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.map }, { children: _jsx("div", Object.assign({ ref: ref, className: 'g-map g-map--static' }, { children: coords && (_jsx(_Fragment, { children: _jsx(GoogleMap, Object.assign({ mapContainerClassName: 'g-map-inner', center: getShiftedCenter, zoom: options.zoom, options: options }, { children: !isCompleted && (
                                // @ts-ignore
                                _jsx(Marker, { position: coords, icon: PointMarkerIcon })) })) })) })) })), isCompleted && (_jsx("div", Object.assign({ className: styles.marker }, { children: _jsx(Icon, { type: "check", size: $windowSize.isMobile ? 56 : 80 }) })))] })) })));
};
export default memo(ApptMap);
